// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2647 10.7338L10.4974 4.76397L12.3053 3L21 12L12.3053 21L10.4974 19.236L16.2647 13.2662L3 13.2662L3 10.7338L16.2647 10.7338Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowRight.js.map